module.exports = __webpack_public_path__ + "static/media/sort-numeric-up-alt.f942d8d4.svg";